export const PAUSE_BUTTON_Z_INDEX = 2;
export const VIDEO_CONTROLS_Z_INDEX = 2;
